import { render, staticRenderFns } from "./inbound-call-message.vue?vue&type=template&id=5ef7e22f"
import script from "./inbound-call-message.vue?vue&type=script&lang=js"
export * from "./inbound-call-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef7e22f')) {
      api.createRecord('5ef7e22f', component.options)
    } else {
      api.reload('5ef7e22f', component.options)
    }
    module.hot.accept("./inbound-call-message.vue?vue&type=template&id=5ef7e22f", function () {
      api.rerender('5ef7e22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/inbound-call-message.vue"
export default component.exports